export default "__VITE_ASSET__SkmM642o__"